const getDefaultStateMinhasVendas = () => ({
  filters: {
    nome_cliente: '',
    nome_bem: '',
    id_documento: '',
    cpfcnpjcliente: '',
    status_pedido: '',
    comissionado: '',
    data_inicial: '',
    data_final: '',
    status_contrato: '',
    tipo_grupo: '',
    quantidade_cotas: '',
    flavor_venda: ''
  },
  dtFiltro: {},
  pagination: {
    page: 1
  },
  activetab: '',
  selectedSaleId: null,
  statusDoContratoSelecionados: [],
  marcasEAdministradorasSelecionadas: [],
  toggle_exclusive: 0,
  isFiltrosAnteriores: false
})

let state = getDefaultStateMinhasVendas()

const mutations = {
  SET_FILTERS (state, filters) {
    state.filters = { ...filters }
  },
  SET_DTFILTRO (state, dtFiltro) {
    state.dtFiltro = { ...dtFiltro }
  },
  SET_PAGINATION (state, pagination) {
    state.pagination = { ...pagination }
  },
  SET_SELECTED_SALE_ID (state, selectedSaleId) {
    state.selectedSaleId = selectedSaleId
  },
  SET_STATUS_DO_CONTRATO_SELECIONADOS (state, statusDoContratoSelecionados) {
    state.statusDoContratoSelecionados = [...statusDoContratoSelecionados]
  },
  SET_MARCAS_E_ADMINISTRADORAS_SELECIONADAS (state, marcasEAdministradorasSelecionadas) {
    state.marcasEAdministradorasSelecionadas = [...marcasEAdministradorasSelecionadas]
  },
  SET_TOGGLE_EXCLUSIVE (state, toggleExclusive) {
    state.toggle_exclusive = toggleExclusive
  },
  SET_IS_FILTROS_ANTERIORES (state, isFiltrosAnteriores) {
    state.isFiltrosAnteriores = isFiltrosAnteriores
  },
  SET_ACTIVE_TAB (state, activeTab) {
    state.activetab = activeTab
  }
}

const actions = {
  resetState ({ commit }) {
    commit('RESET_STATE')
  },
  saveFilters ({ commit }, filters) {
    commit('SET_FILTERS', filters.filters || {})
    commit('SET_DTFILTRO', filters.dtFiltro || {})
    commit('SET_PAGINATION', filters.pagination || { page: 1 })
    commit('SET_SELECTED_SALE_ID', filters.selectedSaleId || null)
    commit('SET_STATUS_DO_CONTRATO_SELECIONADOS', filters.statusDoContratoSelecionados || [])
    commit('SET_MARCAS_E_ADMINISTRADORAS_SELECIONADAS', filters.marcasEAdministradorasSelecionadas || [])
    commit('SET_TOGGLE_EXCLUSIVE', filters.toggle_exclusive || 0)
    commit('SET_ACTIVE_TAB', filters.activetab || 0)
  },
  setIsFiltrosAnteriores ({ commit }, value) {
    commit('SET_IS_FILTROS_ANTERIORES', value)
  }
}

const getters = {
  getFiltrosAnteriores: (state) => {
    return {
      filters: state.filters,
      dtFiltro: state.dtFiltro,
      pagination: state.pagination,
      selectedSaleId: state.selectedSaleId,
      statusDoContratoSelecionados: state.statusDoContratoSelecionados,
      marcasEAdministradorasSelecionadas: state.marcasEAdministradorasSelecionadas,
      toggle_exclusive: state.toggle_exclusive,
      activetab: state.activetab
    }
  }
}

const store = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export { getDefaultStateMinhasVendas }
export default store
